import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  root:{
    display: "flex",
    width: "100%",
    height: "100%",
    alignItems: "center",
    position:"fixed",
    top:0,
    left:0,
    background:"#ECECEC"
  },

    imageIcon: {
      height: "100%",
    },
    iconRoot: {
      textAlign: "center",
    },
    paper: {
      marginTop: theme.spacing(8),
      display: "flex",
      margin:"auto",
      flexDirection: "column",
      alignItems: "center",
      justifyContent:"center",
      maxWidth:"450px",
      width:"90%",  
    },
    avatar: {
      margin: theme.spacing(1),
      backgroundColor: theme.palette.secondary.main,
    },
    form: {
      width: "100%", // Fix IE 11 issue.
      marginTop: theme.spacing(1),
    },
    submit: {
      margin: theme.spacing(3, 0, 2),
    },
    formContainer:{
      background: "#F5F5F5",
      padding: "40px",
      borderRadius: 20,
      boxSizing:"border-box",
      width:"100%"
    }
  }));